/*
 * @Author: liujunhong
 * @Date: 2023/7/17
 * @Desc: 404
 */

import React, { useEffect } from 'react';
import { logRequest } from '@/services';
import { useNavigate } from 'react-router-dom';


const Index = () => {
  const navigate = useNavigate();

  useEffect(() => {

    logRequest({url: window.location.href, source: 'weGame'}).then(res => {
      console.log(res);
    });
    navigate('/');

  }, []);
  return <>
  </>;
};
export default Index;